import { render, staticRenderFns } from "./ConfigTabGeneral.vue?vue&type=template&id=0f5421be"
import script from "./ConfigTabGeneral.vue?vue&type=script&lang=js"
export * from "./ConfigTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports